import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { EErrorType, EUserType } from "./shared/models";
import { Subject, takeUntil, tap } from "rxjs";
import { EExceptionTypes, IAppError } from "src/app/shared/models";
import { AuthStoreService } from "./services-store/auth-store.service";
import { MessageService } from "./shared/services/message.service";

@Injectable({
  providedIn: "root",
})
export class AppService implements OnInit, OnDestroy {
  destroyed$ = new Subject();
  userInfo: any; // Replace `any` with the actual user info model if available
  loadingUserInfo: boolean;
  applicantEmail: string | undefined;

  constructor(
    private authStoreService: AuthStoreService,
    private messageServide: MessageService
  ) {}

  ngOnInit(): void {
    this.setLoadingText();
  }

  setLoadingText = (userType?: EUserType): string => {
    let loadingText: string;
    if (userType && userType === "agent") {
      loadingText = "Loading Application Information... Please Wait";
    } else if (userType && userType === "applicant") {
      loadingText = "Loading Agent Information... Please Wait";
    } else {
      loadingText = "Loading User Information... Please Wait";
    }
    return loadingText;
  };

  selectUserInfo() {
    this.authStoreService.user$
      .pipe(
        tap((userInfo) => {
          this.userInfo = userInfo;

          if (userInfo && !userInfo["agentId"]) {
            // If the user is an applicant, use their login email as their email address
            this.applicantEmail = userInfo.emails[0];
          }
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();

    this.authStoreService.loading$
      .pipe(
        tap((loading) => {
          this.loadingUserInfo = loading;
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  watchUserError() {
    this.authStoreService.error$
      .pipe(
        tap((error: any) => {
          if (error) {
            if (error.type === EErrorType.LOAD) {
              this.messageServide.displayErrorMessage({
                error,
                callback: () => this.authStoreService.verifyAgent(),
                messageFactory: this.errorMessageFactory,
              });
            } else {
              this.messageServide.displayErrorMessage({ error });
            }
          }
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  errorMessageFactory = (error: IAppError) => {
    if (error) {
      switch (error.id) {
        case EExceptionTypes.EXPIRED_AGENT:
          return "Looks like you are no longer a Seneca Agent, please sign out and try another account";
        case EExceptionTypes.INVALID_AGENT_LOGIN:
          return "Invalid Agent login attempt, please sign in with your Agent account instead.";
        case EExceptionTypes.UNABLE_TO_VERIFY_AGENT:
          return "Something went wrong and we cannot verify your identity, please try again.";
        default:
          return "Something went wrong... Please try again";
      }
    }
  };

  ngOnDestroy(): void {
    this.destroyed$.next(1);
    this.destroyed$.unsubscribe();
  }
}
